import React from 'react'
import './Wgbs.css'

import { FaChevronRight } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom';

function Wgbs() {
  
    const navigate = useNavigate();

  return (
    <section className='wgbs-sec'>
        <div className='container'>
            <h3>Why Choose Our </h3>
            <h4>E-Commerce Services? </h4>
            <p className='plg'>We combine conversion-first design with engineering discipline to deliver stores that are easy to manage and built to scale. Our focus on performance, security, and user experience means higher sales and lower churn.
</p>
            <p className='plg'>Add-ons and Growth Services <br/>
            SEO and technical optimisation, mobile commerce optimisation, loyalty and referral systems, analytics and KPI dashboards, and 24/7 support.
            </p>
            <p className='plg'>Ready to convert more visitors into customers? Let’s design your store for growth.

            </p>

            <button className='btn-main' onClick={() => navigate('/contact')}><span>Contact Us</span> <FaChevronRight/></button>
        </div>

    </section>
  )
}

export default Wgbs
